import i18n from 'i18next';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NEW_PRIVACY_POLICY_URL, SUPPORTED_LANGUAGES } from '../../constants';
import { useManageLanguage } from '../../hooks/useManageLanguage';
import { debug } from '../../lib/general';
import style from './Footer.module.css';

const BASE_URL = 'https://prostopay.net/';

const Footer = () => {
    const { t } = useTranslation();
    const { onLanguageChange } = useManageLanguage();
    const [showLanguagePop, setShowLanguagePop] = useState(false);

    return (
        <div className={style.footer}>
            <div className={style.footerLogoBox}>
                <a
                    href={BASE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.footerLogo}
                >
                    <img
                        alt="ProstoPay logo"
                        src="/logo_bottom.svg"
                        className={style.logoSVG}
                    />
                </a>
            </div>
            <div className={style.footerTextBox}>
                <a href={BASE_URL} target="_blank" rel="noopener noreferrer">
                    <span className={style.hrefText}>{t('Copyright')}</span>
                </a>
                <a
                    href={`${NEW_PRIVACY_POLICY_URL}/termsofuse.html`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className={style.hrefText}>{t('Terms_of_use')}</span>
                </a>
            </div>
            <div className={style.footerLangBox}>
                {showLanguagePop && (
                    <ul className={style.languageList}>
                        {SUPPORTED_LANGUAGES.map((language) => (
                            <li
                                key={language}
                                className={
                                    language === i18n.language
                                        ? style.activeLang
                                        : ''
                                }
                                onClick={() => {
                                    debug(`click ${language} ${i18n.language}`, 'info');
                                    onLanguageChange(language);
                                    setShowLanguagePop(false);
                                }}
                            >
                                {t(`Language.${language.toUpperCase()}`)}
                            </li>
                        ))}
                    </ul>
                )}
                <div className={style.languageButton}>
                    <a
                        onClick={() => {
                            debug(`click ${showLanguagePop}`, 'info');
                            setShowLanguagePop(!showLanguagePop);
                        }}
                    >
                        <img
                            height="36px"
                            src="/globe.png"
                            alt="Language change"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export { Footer };
